export type FacilityKey = 'richmond' | 'tacoma';

export interface FacilityConfig {
  id: string;
  label: string;
  address: string;
  cityState: string;
}

export const FACILITIES: Record<FacilityKey, FacilityConfig> = {
  richmond: {
    id: 'd0e84c17-dd2d-448c-9ec3-489f75ba5ce3',
    label: 'Bay Area',
    address: '855 Parr Boulevard, Richmond, CA 94801',
    cityState: 'Bay Area',
  },
  tacoma: {
    id: '00abb9ac-79ee-45db-bbcf-568367b56327',
    label: 'Tacoma, WA',
    address: '2702 South Union Avenue, Tacoma, WA 98405',
    cityState: 'Tacoma, WA',
  },
};

export const FACILITY_KEYS: FacilityKey[] = ['richmond', 'tacoma'];

export function facilityIdFor(key: FacilityKey | null | undefined): string | null {
  if (!key) return null;
  return FACILITIES[key]?.id ?? null;
}
